export const morefilterItems: ISelectOption<string>[] = [
    { value: 'Late Finish Date', label: 'Late Finish Date' },
    { value: 'Late Start Date', label: 'Late Start Date' },
    { value: 'Overrun Duration', label: 'Overrun Duration' },
    { value: 'Milestones', label: 'Milestones' },
];

/**
 * this sort is putting all null in the end of the list
 * @param rowA
 * @param rowB
 */
export const sortFloat = (rowA, rowB) => {
    if (rowA.original.float === null) return 1;
    if (rowB.original.float === null) return -1;
    return rowA.original.float - rowB.original.float;
};
